import { CLEAR_ORGANIZATION_INFO, GET_ORGANIZATION_INFO } from "../../types";
import createAsyncActions from "../../../../utilities/createAsyncActions";
import { createAction } from "redux-actions";

export const {
  getOrganizationInfo,
  getOrganizationInfoPending,
  getOrganizationInfoFulfilled,
  getOrganizationInfoRejected,
} = createAsyncActions(GET_ORGANIZATION_INFO, "getOrganizationInfo");

export const clearOrganizationInfo = createAction(CLEAR_ORGANIZATION_INFO);



// WEBPACK FOOTER //
// ./src/features/organization/actions/getActions/getOrganizationInfoActions.js